import {ErrorHandler} from '@angular/core';

export class NumberUtils {

    /**
     * Formats.
     * @param aNumber
     */
    static formatTwoDecimal(aNumber : number) : string {
        return aNumber ?  aNumber.toFixed(2) : null;
    }

    /**
     * Normalizes to zero
     * @param aNumber
     */
    static normalizeZero(aNumber: number) {
        return (aNumber != null ? aNumber : 0);
    }
}